import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentsRoutingModule } from './payments-routing.module';
import { PaymentPageComponent } from './pages/payment-page/payment-page.component';
import { SharedModule } from '@shared/shared.module';
import { LoadPageComponent } from './pages/load-page/load-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ContinuePageComponent } from './pages/continue-page/continue-page.component';
import { PinPageComponent } from './pages/pin-page/pin-page.component';
import { CountdownTimerComponent } from './pages/countdown-timer/countdown-timer.component';
import { ConfirmationpaymentComponent } from './pages/confirmationpayment/confirmationpayment.component';
import { ConfirmationDAMComponent } from './pages/confirmation-dam/confirmation-dam.component';
import { UpdatecardpageComponent } from './pages/updatecardpage/updatecardpage.component';
import { ContinuePageUpdateComponent } from './pages/continue-page-update/continue-page-update.component';
import { PinPageUpdateComponent } from './pin-page-update/pin-page-update.component';
import { TycComponent } from './pages/tyc/tyc.component';
import { WebstoreConfirmationComponent } from './pages/webstore-confirmation/webstore-confirmation.component';
@NgModule({ declarations: [
        PaymentPageComponent,
        LoadPageComponent,
        ContinuePageComponent,
        PinPageComponent,
        CountdownTimerComponent,
        ConfirmationpaymentComponent,
        ConfirmationDAMComponent,
        UpdatecardpageComponent,
        ContinuePageUpdateComponent,
        PinPageUpdateComponent,
        TycComponent,
        WebstoreConfirmationComponent,
    ], imports: [CommonModule,
        PaymentsRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        MatCheckboxModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PaymentsModule {}
